import React from 'react'
import { StripePaymentStep } from 'member-portal/components'
import { makeMemberApplicationPath, PATH, PAYMENT_STEP_TYPE } from 'config'

const propTypes = {}

function NewMemberPayment() {
  return (
    <StripePaymentStep
      nextStep={makeMemberApplicationPath(PATH.CONFIRM_AND_LOGIN)}
      paymentStepType={PAYMENT_STEP_TYPE.NEW_MEMBERSHIP}
    />
  )
}

NewMemberPayment.propTypes = propTypes

export default NewMemberPayment
